/* eslint-disable */
import { no } from "element-plus/es/locale";
import { createI18n } from "vue-i18n/index";
import { exportToCsv } from "../helpers/exportCsv";

const messages = {
	en: {
		auth: {
			welcome: "Welcome to",
			email: "Email",
			emailPlaceholder: "Enter your email",
			password: "Password",
			passwordPlaceholder: "Enter your password",
			rememberMe: "Remember Me",
			showDemo: "Show demo",
			signIn: "Sign In",
			manufacturer: "Polish manufacturer of home and industrial automation",
			titlep1: "Full",
			titlep2: "control",
			titlep3: "over energy in home and business",
		},
		signInView: {
			signInTitle: "Sign In to Telemetry System",
			email: "Email",
			password: "Password",
			continue: "Continue",
			successfull: "You have successfully logged in!",
			failed: "Try again!",
			confirm: "Ok, got it!",
			rememberMe: "Remember Me",
			token: "Token",
			params: "Params",
			showDemo: "Show demo"
		},
		deviceListWidget: {
			title: "Registered devices",
			total: "Total",
			dName: "Name",
			dModel: "Model",
			dStatus: "Status",
			dActions: "Actions",
			location: "Location",
			tariff: "Tariff",
		},
		deviceDetailsView: {
			currentVoltage: "Actual Voltage",
			current: "Actual Current",
			currentPower: "Actual  Power",
			voltageTitle: "Voltage",
			powerTitle: "Power",
			currentTitle: "Current",
			energyTitle: "Energy active",
			energyTitleExport: "Energy given",
			energyTitleImport: "Energy consumed",
			energyReactiveTitle: "Energy reactive",
			energyReactiveExportTitle: "Energy reactive given",
			energyReactiveImportTitle: "Energy reactive consumed",
			voltageDescription:
				"Shows voltage with min and max values captured in time range.",
			currentDescription:
				"Shows current with min and max values captured in time range.",
			powerDescription:
				"Shows power with min and max values captured in time range.",
			energyDescription:
				"Shows consumed and given away active energy captured in time range.",
			energy3Description:
				"Shows consumed and given away active energy sum from each phases, captured in time range.",
			energyReactiveDescription:
				"Shows consumed and given away reactive energy captured in time range.",
			phase1: "Phase 1",
			phase2: "Phase 2",
			phase3: "Phase 3",
			summary: "Summary",
			phase1dsc: "Phase 1 data",
			phase2dsc: "Phase 2 data",
			phase3dsc: "Phase 3 data",
			summarydsc: "Data of 3 phases",
			power3phasesDescription: "Shows power sum from each phases, captured in time range.",
			voltage3phasesDescription: "Shows voltage from each phases, captured in time range.",
			current3phasesDescription: "Shows current from each phases, captured in time range.",
			energy3phasesImportDescription:
				"Shows consumed energy sum from each phases, captured in time range.",
			energy3phasesExportDescription:
				"Shows given away energy sum from each phases, captured in time range.",
			energyReactive3phasesImportDescription:
				"Shows consumed reactive energy sum from each phases, captured in time range.",
			energyReactive3phasesExportDescription:
				"Shows given away reactive energy sum from each phases, captured in time range.",
			energyConsumption: "Energy consumption",
			fromBillingPeriod: "From the billing period",
			selectBillingPeriod: "Select billing period",
			noBillingPeriod: "Billing periods not set.",
			active: "Active",
			reactive: "Reactive",
			volt: "Volts",
			amper: "Amps",
			watt: "Watts",
			outPower: "given",
			details: "Details",
			energyProductionTitle: "Energy production",
			carbonEmissionHint: "Your carbon emission is less. Thank you!",
			energyProductionDescription: "Shows given away active energy captured in time range.",
			solarPowerDescription: "Shows power value captured in time range.",
			energyBalance: "Balance",
			energyBalanceDescription: "Balance of active energy imported and exported, recorded in a time interval.",
			selectView: "Select view",
			relayState: "Relay state",
			rel1: "Output relay",
			tempmain: "Current temperature",
			tempset: "Set temperature",
			energyActiveDescription: "This is the energy that is actually used to perform work, e.g. power devices, and is measured in kilowatt-hours (kWh), which is used to calculate electricity charges.",
			eneryToday: "Today",
			monthly: "This month",
			yearly: "This year",
			total: "Total",
			thermoTitle: "Thermostat",
			thermoDescription: "Shows output relay state, current and set temperature values.",
			relayOutputEnable: "Output enabled",
			relayOutputDisable: "Output disabled",
			currentTemperature: "Current temperature",
			setTemperature: "Set temperature",
			thermoAlarmDesc: "The device status is monitored in real time and the data is displayed in real time.",
			today: "Today",
			production: "Production",
			consumption: "Consumption",
			energyMeterMenuTitle: "Display energy including meter status",
			energyMeterResetDefaultsHint: "Do not include the above data when displaying energy consumption (restore default settings).",
			energyMeterValueSavedSuccessfully: "Energy meter data successfully saved",
			energyMeterValueSavedError: "Failed to save energy meter data",
			energyActiveSelectorDescription: "Active energy is that part of electrical energy that is actually converted into work (e.g. heat, light, movement) by electrical devices and is measured in kilowatt-hours (kWh).",
			energyReactiveSelectorDescription: "Reactive energy is the component of electrical energy that does not perform useful work but is necessary to produce a magnetic field in devices such as motors and transformers, measured in kilovar ampere-hours (kVArh).",
			limitValuesTitle: "Limit values",
			limitValuesVoltageDesc: "Set voltage limits as a percentage of the nominal 230V",
			limitWarningValue: "Warning level",
			limitWarnigDesc: "Value approaching the limit",
			limitCriticalValue: "Critical level",
			limitCriticalDesc: "Value exceeding the limit",
			limitsValuesSavedSuccessfully: "Limit values saved successfully",
			limitsValuesSavedError: "Failed to save limit values",
			deviceDeleted: "Device successfully deleted",
			errorDeletingDevice: "Error deleting device",
			deviceDeletingTitle: "Are you sure you want to delete this device?",
			deviceDeletingPrompt: "This operation is irreversible and will delete all data related to this device.",
			followedTariff: "Tariff balance",
			comparations: {
				iaveTitle: "Current",
				iaveDescription: "Shows current current value from each phase, captured in time range.",
				paveTitle: "Power",
				paveDescription: "Shows power value from each phase, captured in time range.",
				vaveTitle: "Voltage",
				vaveDescription: "Chart shows voltage from each phase, captured in time range.",
				power3phasesTitle: "Power sum",
				power3phasesDescription: "Chart shows power sum from each phases, captured in time range.",
				ienergy3phasesTitle: "Sum of active energy consumed and given",
				ienergy3phasesDescription: "Chart shows sum of active energy consumed and given from each phases, captured in time range.",
				oenergy3phasesTitle: "Balance of active energy",
				oenergy3phasesDescription: "Chart shows balance of active energy - the difference between energy given and consumed from three phases, captured in time range.",
				"pave;pmin;pmaxTitle": "Power - average, min, max",
				"pave;pmin;pmaxDescription": "Chart shows power - average, min, max from selected phase, captured in time range.",
				"vave;vmin;vmaxTitle": "Voltage - average, min, max",
				"vave;vmin;vmaxDescription": "Chart shows voltage - average, min, max from selected phase, captured in time range.",
				"iave;imin;imaxTitle": "Current - average, min, max",
				"iave;imin;imaxDescription": "Chart shows current - average, min, max from selected phase, captured in time range.",
				ioenergyTitle: "Active energy - consumed and given",
				ioenergyDescription: "Chart shows active energy - consumed and given from selected phase, captured in time range.",
				renergyTitle: "Reactive energy - consumed and given",
				renergyDescription: "Chart shows reactive energy - consumed and given from selected phase, captured in time range.",
				compatarationSavingErrorTitle: "Error saving comparations",
				compatarationSavingErrorDesc: "Your comparations were not saved on the server. After refreshing the page, the view will return to the last saved state.",
				cenergy: "Capacitive reactive energy - consumed and given",
				indenergy: "Inductive reactive energy - consumed and given"
			},
			powerTitleAvg: "Power average, min, max",
			voltageTitleAvg: "Voltage average, min, max",
			currentTitleAvg: "Current average, min, max",
			provideConsumption: "Type consumption",
			editConsumption: "Edit consumption",
		},
		alarms: {
			noWarnings: "No warnings",
		},
		chartsDropdowns: {
			chartOptions: "Chart options",
			date: "Select date",
			dateRange: "Select date range",
			simpleChartDateHint: "Data will be shown from start date plus 24h.",
			reset: "Reset",
			apply: "Apply",
		},
		pagesTitle: {
			dashboard: "Dashboard",
			devicedetails: "Device overview",
			deviceData: "Device data",
			deviceEdit: "Edit device",
			locationIndex: "Locations",
			locationDetails: "Location list",
			tariffsBalance: "Tariffs balance",
			analytics: "Comparative analysis",
		},
		time: {
			hour: "Hour",
			minute: "Minute",
			seconds: "Seconds",
			day: "Day",
			month: "Month",
			week: "Week",
			year: "Year",
			range: "Time range"
		},
		notifications: {
			title: "Notifications",
			events: "Events",
			empty: "No new notifications.",
			showAll: "View all",
		},
		themeMenu: {
			title: "Theme",
			light: "Light",
			dark: "Dark",
			system: "System"
		},
		devParameters: {
			pave1: "Power L1",
			pave2: "Power L2",
			pave3: "Power L3",
			pmax1: "Power L1 - max",
			pmax2: "Power L2 - max",
			pmax3: "Power L3 - max",
			pmin1: "Power L1 - min",
			pmin2: "Power L2 - min",
			pmin3: "Power L3 - min",
			vave1: "Voltage L1",
			vave2: "Voltage L2",
			vave3: "Voltage L3",
			vmax1: "Voltage L1 - max",
			vmax2: "Voltage L2 - max",
			vmax3: "Voltage L3 - max",
			vmin1: "Voltage L1 - min",
			vmin2: "Voltage L2 - min",
			vmin3: "Voltage L3 - min",
			iave1: "Current L1",
			iave2: "Current L2",
			iave3: "Current L3",
			imax1: "Current L1 - max",
			imax2: "Current L2 - max",
			imax3: "Current L3 - max",
			imin1: "Current L1 - min",
			imin2: "Current L2 - min",
			imin3: "Current L3 - min",
			eai1: "Active energy import L1",
			eai2: "Active energy import L2",
			eai3: "Active energy import L3",
			eae1: "Active energy export L1",
			eae2: "Active energy export L2",
			eae3: "Active energy export L3",
			eri1: "Reactive energy import L1",
			eri2: "Reactive energy import L2",
			eri3: "Reactive energy import L3",
			ere1: "Reactive energy export L1",
			ere2: "Reactive energy export L2",
			ere3: "Reactive energy export L3",
			pfave1: "Power factor L1",
			pfave2: "Power factor L2",
			pfave3: "Power factor L3",
			pfmax1: "Power factor L1 - max",
			pfmax2: "Power factor L2 - max",
			pfmax3: "Power factor L3 - max",
			pfmin1: "Power factor L1 - min",
			pfmin2: "Power factor L2 - min",
			pfmin3: "Power factor L3 - min",
			energy3phases: "Total energy export",
			renergy3phases: "Total reactive energy export",
			power3phases: "Power sum",
			energy3phases_export: "Total energy export",
			energy3phases_import: "Total energy import",
			renergy3phases_export: "Total reactive energy export",
			renergy3phases_import: "Total reactive energy import",
			frq1: "Frequency",
			vdc1: "Voltage DC1",
			vdc2: "Voltage DC2",
			vdc3: "Voltage DC3",
			idc1: "Current DC1",
			idc2: "Current DC2",
			alarm: "Alarm",
			balance: "Balance",
			tempmain: "Current temperature",
			tempset: "Set temperature",
			rel1: "Output relay",
			eric1: "Capacitive reactive energy imported phase 1",
			erec1: "Capacitive reactive energy exported phase 1",
			erii1: "Inductive reactive energy imported phase 1",
			erei1: "Inductive reactive energy exported phase 1",
			eric2: "Capacitive reactive energy imported phase 2",
			erec2: "Capacitive reactive energy exported phase 2",
			erii2: "Inductive reactive energy imported phase 2",
			erei2: "Inductive reactive energy exported phase 2",
			eric3: "Capacitive reactive energy imported phase 3",
			erec3: "Capacitive reactive energy exported phase 3",
			erii3: "Inductive reactive energy imported phase 3",
			erei3: "Inductive reactive energy exported phase 3",
			prave1: "Reactive power average phase 1",
			prmax1: "Reactive power maximum phase 1",
			prmin1: "Reactive power minimum phase 1",
			prave2: "Reactive power average phase 2",
			prmax2: "Reactive power maximum phase 2",
			prmin2: "Reactive power minimum phase 2",
			prave3: "Reactive power average phase 3",
			prmax3: "Reactive power maximum phase 3",
			prmin3: "Reactive power minimum phase 3",
		},
		userProfile: {
			account: "Account",
			title: "Profile details",
			edit: "Edit profile",
			myProfile: "My profile",
			language: "Language",
			email: "Email addess",
			emailTooltip: "Email cannot be edited",
			fullname: "Full name",
			country: "Country",
			timezone: "Timezone",
			countryTooltip: "Country of installation, useful to set timezone",
			countryRequired: "Country is required",
			timezoneTooltip: "Timezone of device installation",
			timezoneRequired: "Timezone is required",
			infoTitleOk: "Everything is ok!",
			infoDescriptionOk: "It looks like we didn't find any issues with your account.",
			infoTitleWrong: "We need your attention",
		},
		languages: {
			english: "English",
			polish: "Polish",
			turkish: "Turkish",
			spanish: "Spanish",
		},
		forms: {
			successfullySaved: "Data has been successfully saved.",
			successfullyExported: "Data was exported successfully.",
			errorInSaving: "Unable to save data. Check form.",
			errorInExporting: "Exporting data failed.",
			submit: "Submit",
			discard: "Discard",
			ok: "Ok",
			okGotIt: "Ok, got it!",
			edit: "Edit",
			cancel: "Cancel",
			export: "Export",
			save: "Save",
			provideEnergyMeterValue: "Provide energy meter value",
			provideEnergyMeterValueHint: "The entered value will be included in the calculation of the meter reading with the measured energy consumption of the device.",
			dateFrom: "Date from",
			dateTo: "Date to",
		},
		deviceOverview: {
			title: "Device details",
			edit: "Edit device",
			name: "Known name",
			friendlyName: "Common name",
			typeName: "Type name",
			mac: "Mac",
			modelName: "Model name",
			registeredDate: "Registered date",
			modifiedDate: "Modified date",
			registeredDateTooltip: "Date when device was registered",
			modifiedDateTooltip: "Date when device modified itself",
			nameTooltip: "User defined name, you can change it",
			billingStartDate: "Billing period, start date",
			billingNoMonths: "Number of months in billing period",
			defaultTariff: "Device billing tariff",
			location: "Location",
			notificationsFromDevice: "Notifications from device",
			notificationsEnabled: "Enabled",
			notificationsDisabled: "Disabled",
			notifyWhenVoltageDrops: "Notify when voltage drops under",
			notifyWhenVoltageRises: "Notify when voltage exceeds more than",
			notifyWhenTotalCosumptionAbove: "Notify when total energy consumption exceeds more than",
			disableNotificationsAtNight: "Disable notifications at night (22:00 - 7:00)",
			notificationInterval: "Notification interval",
			muteNotifications: "Mute notifications",
			muteNotificationsInfo: "Notifications will not be sent from the telemetry system. Includes all types of notifications."
		},
		tariff: {
			pageTitle: "Stats of energy consumption",
			chceckUsages: "Check usages",
			g11Description: "Podstawowa taryfa roliczenieowa. Jedna stawka za energię elektryczną o każdej porze dnia i nocy.",
			g12Description: "Taryfa dwustrefowa. Dla korzystających z energii elektrycznej głównie w nocy, w szczególności na potrzeby ogrzewania.",
			g12asDescription: "Taryfa dwustrefowa. Dostosowana do celów grzewczych.",
			g12rDescription: "Taryfa dwustrefowa. Podobna do g12, nastawiona jeszcze bardziej na zużycie energii w nocy.",
			g12nDescription: "Taryfa dwustrefowa. Rozliczenie w taryfie dzienne i nocnej z rozszerzoną strefą nocną o niedzielę.",
			g12wDescription: "Taryfa dwustrefowa. Niższa cena prądu w weekend, w nocy i wybranych godzinach dnia.",
			profitCostText: "Potentail cost/profit",
			currentConsumption: "Current consumption",
			showCosts: "Show costs",
			area1: "Day zone",
			area2: "Night zone",
			currentUsageDescription: "Energy consumption for the current month at the default tariff",
			attentionInfo: "The presented data are simulated and cannot be basis for potential claims against any subject.",
			yourTariff: "Your tariff",
			tariffsTitile: "Tariffs",
			priceArea1: "Price in area one (daily)",
			priceArea2: "Price in area two (nightly)",
			priceArea3: "Price in area third",
			priceConst: "Const price",
			priceConstInfo: "Caluclate all fixed prices from your invoice and set it here",
			g11SummaryText: "Basic household tariff",
			gxSummaryText: "You consume energy in two zones: day and night",
			//opisy dla taryf, przenieść tłumaczenia
			area1_2: "Day/night zone",
			g11DescTitile: "Tariff G11",
			g12DescTitile: "Tariff G12",
			g12asDescTitile: "Tariff G12as",
			g12nDescTitile: "Tariff G12n",
			g12rDescTitile: "Tariff G12r",
			g12wDescTitile: "Tariff G12w",
			monday_sunday: "Monday - sunday",
			monday_saturday: "Monday - saturday",
			monday_friday: "Monday - friday",
			saturdaySunday: "Saturday, sunday and holidays",
			sundayFeasts: "Sunday and holidays",
			zone: "Zone",
			wholeDay: "Round the clock",
			tariffRule: "Tariff rule:",
			g11DescRule: "One rate for electricity at any time of the day or night. The offer will be given to those using electricity mainly during the day, not using electricity for heating purposes.",
			g12DescRule: "It enables the settlement of consumed energy in two time zones. An offer for those who use electricity mainly at night, in particular for heating purposes.",
			g12asDescRule: "Two-zone group: day and night zone.",
			g12nDescRule: "Two-zone group: day and night zones with extended night zone by Sunday.",
			g12rDescRule: "Extended two-zone group: day and night zones.",
			g12wDescRule: "An offer for customers using day and night heating, with the night zone extended to include Saturdays and Sundays",
			cheaper: "Cheaper",
			moreExpensive: "more expensive",
			nightPeriod: "Night period",
			dailyPeriod: "Daily period",
			southernPeriod: "Southern period",
			morningPeriod: "Morning period",
			eveningPeriod: "Evening period",
			selectTariff: "Select tariff",
			noTariffSelected: "Didn't choose a tariff",
			compareTariff: "Compare tariffs",
			compareTariffDescription: "You can compare your current and recent usage with the other tariffs to help you choose the right tariff for your new billing period."
		},
		location: {
			indexTitle: "Locations",
			name: "Name",
			code: "Code",
			address: "Address",
			city: "City",
			timezone: "Time Zone",
			energyTariff: "Eneregy Tariff",
			edit: "Edit location",
			yourLocations: "Your locations",
			newLocationTitle: "Add new location",
			availableEnergyTariffs: "Available energy tariffs",
			resetDefaut: "Reset default",
			restoredDefault: "Restored to default values",
			successfullyDeleted: "Location successfully deleted",
		},
		toasts: {
			success: "Success",
			warning: "Warning",
			info: "Info",
			help: "Help",
			weakWiFiSignal: {
				title: "Network connection problem",
				description: "Weak Fox device WiFi signal or device is offline",
			}
		},
		validators: {
			number: "Must be a valid number, fix your input",
			min: "Must be greater than or equal to ",
			max: "Must be less than or equal to ",
			dateRange: "Date range is required",
			parameterMin: "Please select at least one parameter",
			exportTo: "Select file type to export",
			required: "Field cannot be empty",
			warningLevelGreater: "Warning level must be less than critical level",
			warningLevelRange: "Warning level must be in range 0-50%",
			criticalLevelLess: "Critical level must be greater than warning level",
			criticalLevelRange: "Critical level must be in range 0-100%",
			comparationNameLength: "Name of comparation must be between 3 and 30 characters",
			selectAtLeastOneParameter: "Select at least one parameter to compare",
			invalidEmail: "Email is not valid",
			passwordLength: "Password must be at least 4 characters long",
		},
		exportData: {
			title: "Export data",
			parameters: "Parameters",
			parametersHint: "Select parameters to export",
			dateRange: "Select date range",
			customFileName: "Custom file name",
			customFileNameHint: "Type custom file name or leave empty",
			exportAllParams: "Export all available parameters",
			exportTo: "Export to file type",
			exportUnavailableTitle: "Export unavailable",
			exportUnavailableDesc: "Export is unavailable because server is busy. Try again later.",
			exportInBackround: "Exporting data scheduled. We will inform you when file be ready.",
			exportToCsv: "Export to CSV",
			exportToPdf: "Export to PDF",
			print: "Print",
		},
		times: {
			min15: "15 min.",
			min30: "30 min.",
			min60: "1 hour",
			min1440: "24 hours"
		},
		analytics: {
			selectOperation: "Select action",
			dailyHeatmap: "Daily energy consumption (heatmap)",
			monthlyHeatmap: "Monthly energy consumption (heatmap)",
			weeklyHeatmap: "Weekly energy consumption (heatmap)",
			yearlyHeatmap: "Yearly energy consumption (heatmap)",
			selectDevices: "Select devices",
			selectDateRange: "Select date range",
			sumCmpDesc: "Sum of energies consump.",
			compareTitle: "Comparative analysis",
			compareDescription: "Compare devices parameters with predefined action or create your own",
			noData: "No data",
			analyze: "Analyze",
			datetimeRangeConsumption: "Datetime range energy consumption (table)",
			dateTimeEnergyConsumption: "Energy consumption in period",
		},
		comparation: {
			newComparation: "New comparation",
			shortDesccription: "System allows you to compare parameters of devices eg. power, voltage, current, energy, etc.",
			name: "Name of comparation",
			namePlaceholder: "Provide name of comparation",
			selectParametrsTitle: "Select parameters to compare",
			showGroupedParametes: "Show grouped parameters (on same chart) - there where possible",
			deleteCard: "Are you sure you want to delete tab with name",
			deleteCardDesc: "This operation is irreversible and will delete all data - make sure you want to do it.",
		},
		actions: {
			compare: "Compare",
			cancel: "Cancel",
			delete: "Delete",
			back: "Back",
			close: "Close",
			save: "Save",
		},
		menu: {
			analytics: "Analytics",
			locations: "Locations",
			tarrifs: "Tariffs",
			readouts: "Device readouts",
			settings: "Settings",
			signOut: "Sign out",
			deviceList: "Device List",
			navigation: "Navigation",
		},
		providedBy: "Provided by",
		manufacturer: "F&F Filipowski Sp. k.",
		pleaseWait: "Please wait...",
		dashboard: "Dashboard",
		authentication: "Authentication",
		signIn: "Sign-in",
		signUp: "Sign-up",
		signOut: "Sign out",
		passwordReset: "Password Reset",
		error404: "Seems there is nothing here",
		error500: "Internal server error. Please contact with server administrator.",
		daily: "Daily",
		monthly: "Monthly",
		yearly: "Yearly",
		total: "Total",
		select: "Select",
		noData: "Empty results",
		add: "Add",
		deletePrompt: "Confirm delete operation. Are you shure?",
		yes: "Yes",
		no: "No",
		edit: "Edit",
		attention: "Attention",
		date: "Date",
		selectDate: "Select date",
		selectDateGlobalDesc: "Selected date will be assigned to all charts",
		energyTableView: "Table view",
		lp: "No.",
		value: "Value",
		unit: "Unit",
		on: "On",
		off: "Off",
		temperature: "Temperature",
		dataRangeOverflow: "No data available. Change date to day range.",
		selectInterestedDate: "Select interested date",
		delete: "Delete",
		phase: "Phase",
		sum: "Sum",
		device: "Device",
		changesSavedSuccessfully: "Changes saved successfully",
	},
	pl: {
		auth: {
			welcome: "Witaj w",
			email: "Email",
			emailPlaceholder: "Podaj swój email",
			password: "Hasło",
			passwordPlaceholder: "Podaj swoje hasło",
			rememberMe: "Zapamiętaj mnie",
			showDemo: "Pokaż demo",
			signIn: "Zaloguj się",
			manufacturer: "Polski producent automatyki domowej i przemysłowej",
			titlep1: "Pełna",
			titlep2: "kontrola",
			titlep3: "nad energią w domu i firmie",
		},
		signInView: {
			signInTitle: "Zaloguj się do systemu Telemetrii",
			email: "Email",
			password: "Hasło",
			continue: "Kontynuuj",
			successfull: "Zalogowano!",
			failed: "Spróbuj ponownie!",
			confirm: "Ok",
			rememberMe: "Zapamiętaj mnie",
			token: "Token",
			params: "Params",
			showDemo: "Zobacz demo"
		},
		deviceListWidget: {
			title: "Zarejestrowane urządzenia",
			total: "Ilość",
			dName: "Nazwa",
			dModel: "Model",
			dStatus: "Status",
			dActions: "Akcje",
			location: "Lokalizacja",
			tariff: "Taryfa",
		},
		deviceDetailsView: {
			currentVoltage: "Aktualne napięcie",
			current: "Aktualne natężenie",
			currentPower: "Aktualna moc",
			voltageTitle: "Napięcie",
			powerTitle: "Moc",
			currentTitle: "Prąd",
			energyTitle: "Energia czynna",
			energyReactiveTitle: "Energia bierna",
			energyTitleExport: "Energia oddana",
			energyTitleImport: "Energia pobrana",
			energyReactiveExportTitle: "Energia bierna oddana",
			energyReactiveImportTitle: "Energia bierna pobrana",
			voltageDescription:
				"Wartość napięcia z poziomiem min. i max. zarejestrowana w przedziale czasu.",
			currentDescription:
				"Wartość prądu z poziomiem min. i max. zarejestrowana w przedziale czasu.",
			powerDescription:
				"Wartość mocy z poziomem min. i max. zarejestrowana w przedziale czasu.",
			energyDescription:
				"Wartość energii czynnej pobranej i oddanej, zarejestrowana w przedziale czasu.",
			energy3Description:
				"Wartość energii czynnej pobranej i oddanej (zsumowna z 3 faz), zarejestrowana w przedziale czasu.",
			energyReactiveDescription:
				"Wartość energii biernej pobranej i oddanej, zarejestrowana w przedziale czasu.",
			phase1: "Faza 1",
			phase2: "Faza 2",
			phase3: "Faza 3",
			summary: "Podsumowanie",
			phase1dsc: "Wartości fazy 1",
			phase2dsc: "Wartości fazy 2",
			phase3dsc: "Wartości fazy 3",
			summarydsc: "Zagregowane wartości z 3 faz.",
			power3phasesDescription: "Suma mocy z 3 faz, zarejestrowana w przedziale czasu.",
			voltage3phasesDescription: "Wartość napięcia z każdej fazy, zarejestrowana w przedziale czasu.",
			current3phasesDescription: "Wartość natężenia z każdej fazy, zarejestrowana w przedziale czasu.",
			energy3phasesImportDescription:
				"Suma energii pobranej z 3 faz, zarejestrowana w przedziale czasu.",
			energy3phasesExportDescription:
				"Suma energii oddanej z 3 faz, zarejestrowana w przedziale czasu.",
			energyReactive3phasesImportDescription:
				"Suma pobranej energii biernej z 3 faz, zarejestrowana w przedziale czasu.",
			energyReactive3phasesExportDescription:
				"Suma oddanej energii biernej z 3 faz, zarejestrowana w przedziale czasu.",
			energyConsumption: "Zużycie energii",
			fromBillingPeriod: "Z okresu rozliczeniowego",
			selectBillingPeriod: "Wybierz okres rozliczeniowy",
			noBillingPeriod: "Brak zdefiniowanych okresów rozliczeniowych.",
			active: "Czynnej",
			reactive: "Biernej",
			volt: "Woltów",
			amper: "Amperów",
			watt: "Watów",
			outPower: "oddana",
			details: "Szczegóły",
			energyProductionTitle: "Produkcja energii",
			carbonEmissionHint: "Twój ślad węglowy jest niższy. Dziękujemy, że dbasz o naszą planetę!",
			energyProductionDescription: "Wartość energii oddanej, zarejestrowana w przedziale czasu",
			solarPowerDescription: "Wartość mocy zarejestrowana w przedziale czasu.",
			energyBalance: "Bilans energii",
			energyBalanceDescription: "Bilans energii czynnej pobranej i oddanej, zarejestrowanej w przedziale czasu.",
			selectView: "Wybierz widok",
			relayState: "Stan przekaźnika",
			energyActiveSelectorDescription: "Energia czynna to ta część energii elektrycznej, która jest faktycznie zamieniana na pracę (np. ciepło, światło, ruch) przez urządzenia elektryczne i jest mierzona w kilowatogodzinach (kWh).",
			energyReactiveSelectorDescription: "Energia bierna to składowa energii elektrycznej, która nie wykonuje użytecznej pracy, ale jest niezbędna do wytworzenia pola magnetycznego w urządzeniach takich jak silniki czy transformatory, mierzona w kilovarogodzinach (kVArh).",
			eneryToday: "Dzisiaj",
			monthly: "W tym miesiącu",
			yearly: "W tym roku",
			total: "Od początku",
			thermoTitle: "Termostat",
			thermoDescription: "Zarejestrowane wartości stanu wyjścia, temperatury odczytanej i zadanej.",
			relayOutputEnable: "Wyjście włączone",
			relayOutputDisable: "Wyjście wyłączone",
			currentTemperature: "Aktualna temperatura",
			setTemperature: "Temperatura zadana",
			thermoAlarmDesc: "Stan urządzenia jest na bieżąco monitorowany, a dane wyświetlane sa w czasie rzeczywistym",
			today: "dziś",
			production: "Produkcja",
			consumption: "Zużycie",
			energyMeterMenuTitle: "Wyświetlanie energii z uwzględnieniem stanu licznika dostawcy",
			energyMeterResetDefaultsHint: "Nie uwzględniaj powyższych danych przy wyświetlaniu zużycia energii (przywróć ustawienia podstawowe).",
			energyMeterValueSavedSuccessfully: "Poprawnie zapisano dane licznika energii",
			energyMeterValueSavedError: "Nie udało się zapisać danych licznika energii",
			limitValuesTitle: "Wartości graniczne",
			limitValuesVoltageDesc: "Ustal wartości graniczne jako procent wartości wyjściowej 230V",
			limitWarningValue: "Wartość ostrzegająca",
			limitWarnigDesc: "Wartość zbliżająca się do granicy.",
			limitCriticalValue: "Wartość przekroczona",
			limitCriticalDesc: "Wartość poza bezpiecznym zakresem.",
			limitsValuesSavedSuccessfully: "Poprawnie zapisano wartości graniczne",
			limitsValuesSavedError: "Nie udało się zapisać wartości granicznych",
			deviceDeletingTitle: "Czy na pewno chcesz usunąć to urządzenie?",
			deviceDeletingPrompt: "Operacja jest nieodwracalna i spowoduje usunięcie wszystkich danych związanych z tym urządzeniem",
			deviceDeleted: "Pomyślnie usunięto urządzenie",
			errorDeletingDevice: "Nie udało się usunąć urządzenia",
			followedTariff: "Według taryfy",
			comparations: {
				vaveTitle: "Napięcie fazowe",
				vaveDescription: "Wykres przedstawia wartości napięcia z każdej fazy dla wybranego zakresu czasu.",
				iaveTitle: "Prąd fazowy",
				iaveDescription: "Wykres przedstawia wartości prądu z każdej fazy dla wybranego zakresu czasu.",
				paveTitle: "Moc",
				paveDescription: "Wykres przedstawia wartość mocy dla wybranej fazy i zakresu czasu.",
				power3phasesTitle: "Suma mocy",
				power3phasesDescription: "Wykres przedstawia sumę mocy z trzech faz dla wybranego zakresu czasu.",
				ienergy3phasesTitle: "Suma energii pobranej i oddanej",
				ienergy3phasesDescription: "Wykres przedstawia sumę energii pobranej i oddanej z trzech faz dla wybranego zakresu czasu.",
				oenergy3phasesTitle: "Bilans energii",
				oenergy3phasesDescription: "Wykres przedstawia bilans energii - różnicę między energią oddaną a pobraną z trzech faz dla wybranego zakresu czasu.",
				"pave;pmin;pmaxTitle": "Moc - średnia, min, max",
				"pave;pmin;pmaxDescription": "Wykres przedstawia moc średnią, minimalną i maksymalną dla wybranego zakresu czasu i fazy.",
				"vave;vmin;vmaxTitle": "Napięcie - średnia, min, max",
				"vave;vmin;vmaxDescription": "Wykres przedstawia napięcie średnie, minimalne i maksymalne dla wybranego zakresu czasu i fazy.",
				"iave;imin;imaxTitle": "Natężenie - średnia, min, max",
				"iave;imin;imaxDescription": "Wykres przedstawia prąd średni, minimalny i maksymalny dla wybranego zakresu czasu i fazy.",
				ioenergyTitle: "Energia czynna - pobrana i oddana",
				ioenergyDescription: "Wykres przedstawia energię czynną pobraną i oddaną dla wybranego zakresu czasu i fazy.",
				renergyTitle: "Energia bierna - pobrana i oddana",
				renergyDescription: "Wykres przedstawia energię bierną pobraną i oddaną dla wybranego zakresu czasu i fazy.",
				compatarationSavingErrorTitle: "Wystąpił błąd podczas zapisywania danych",
				compatarationSavingErrorDesc: "Twoje porównania nie zostały zapisane na serwerze. Po odświeżeniu strony, widok wróci do ostatnio zapamiętanego stanu.",
				cenergyTitle: "Energia bierna pojemnościowa - pobrana i oddana",
				cenergyDescription: "Wykres przedstawia energię bierną pojemnościową pobraną i oddaną dla wybranego zakresu czasu i fazy.",
				indenergyTitle: "Energia bierna indukcyjna - pobrana i oddana",
				indenergyDescription: "Wykres przedstawia energię bierną indukcyjną pobraną i oddaną dla wybranego zakresu czasu i fazy."
			},
			powerTitleAvg: "Moc średnia, min, max",
			voltageTitleAvg: "Napięcie średnie, min, max",
			currentTitleAvg: "Prąd średni, min, max",
			provideConsumption: "Wprowadź zużycie",
			editConsumption: "Edytuj zużycie",
		},
		alarms: {
			noWarnings: "Brak ostrzeżeń",
		},
		chartsDropdowns: {
			chartOptions: "Opcje wykresu",
			date: "Wybierz datę",
			dateRange: "Wybierz zakres dat",
			simpleChartDateHint: "Dane na wykresie będą widoczne z przedziału: wybrana data plus 24 godziny",
			reset: "Reset",
			apply: "Zastosuj",
		},
		pagesTitle: {
			dashboard: "Dashboard",
			devicedetails: "Informacje o urządzeniu",
			deviceData: "Odczyty urządzenia",
			deviceEdit: "Edytuj dane urządzenia",
			locationIndex: "Lokalizacje",
			locationDetails: "Lista lokalizacji",
			tariffsBalance: "Zużycie energii według taryfy",
			analytics: "Analiza porównawcza"
		},
		time: {
			hour: "Godzina",
			minute: "Minuta",
			seconds: "Sekundy",
			day: "Dzień",
			month: "Miesiąc",
			week: "Tydzień",
			year: "Rok",
			range: "Zakres czasowy"
		},
		notifications: {
			title: "Notyfikacje",
			events: "Zdarzenia",
			empty: "Brak nowych notyfikacji",
			showAll: "Zobacz wszystkie",
		},
		themeMenu: {
			title: "Motyw",
			light: "Jasny",
			dark: "Ciemny",
			system: "System"
		},
		devParameters: {
			pave1: "Moc L1",
			pave2: "Moc L2",
			pave3: "Moc L3",
			pmax1: "Moc L1 - max",
			pmax2: "Moc L2 - max",
			pmax3: "Moc L3 - max",
			pmin1: "Moc L1 - min",
			pmin2: "Moc L2 - min",
			pmin3: "Moc L3 - min",
			vave1: "Napięcie L1",
			vave2: "Napięcie L2",
			vave3: "Napięcie L3",
			vmax1: "Napięcie L1 - max",
			vmax2: "Napięcie L2 - max",
			vmax3: "Napięcie L3 - max",
			vmin1: "Napięcie L1 - min",
			vmin2: "Napięcie L2 - min",
			vmin3: "Napięcie L3 - min",
			iave1: "Natężenie L1",
			iave2: "Natężenie L2",
			iave3: "Natężenie L3",
			imax1: "Natężenie L1 - max",
			imax2: "Natężenie L2 - max",
			imax3: "Natężenie L3 - max",
			imin1: "Natężenie L1 - min",
			imin2: "Natężenie L2 - min",
			imin3: "Natężenie L3 - min",
			eai1: "Energia pobrana L1",
			eai2: "Energia pobrana L2",
			eai3: "Energia pobrana L3",
			eae1: "Energia oddana L1",
			eae2: "Energia oddana L2",
			eae3: "Energia oddana L3",
			eri1: "Energia bierna pobrana L1",
			eri2: "Energia bierna pobrana L2",
			eri3: "Energia bierna pobrana L3",
			ere1: "Energia bierna oddana L1",
			ere2: "Energia bierna oddana L2",
			ere3: "Energia bierna oddana L3",
			pfave1: "Współczynnik mocy L1",
			pfave2: "Współczynnik mocy L2",
			pfave3: "Współczynnik mocy L3",
			pfmax1: "Współczynnik mocy L1 - max",
			pfmax2: "Współczynnik mocy L2 - max",
			pfmax3: "Współczynnik mocy L3 - max",
			pfmin1: "Współczynnik mocy L1 - min",
			pfmin2: "Współczynnik mocy L2 - min",
			pfmin3: "Współczynnik mocy L3 - min",
			energy3phases: "Całkowita energia",
			renergy3phases: "Całkowita energia bierna",
			power3phases: "Suma mocy",
			energy3phases_export: "Całkowita energia oddana",
			energy3phases_import: "Całkowita energia pobrana",
			renergy3phases_export: "Całkowita energia bierna, oddana",
			renergy3phases_import: "Całkowita energia bierna, pobrana",
			frq1: "Częstotliwość",
			vdc1: "Napięcie DC1",
			vdc2: "Napięcie DC2",
			vdc3: "Napięcie DC3",
			idc1: "Natężenie DC1",
			idc2: "Natężenie DC2",
			alarm: "Alarm",
			balance: "Bilans",
			tempmain: "Temperatura odczytana",
			tempset: "Temperatura zadana",
			rel1: "Wyjście przekaźnika",
			eric1: "Pobrana energia bierna pojemnościowa faza 1",
			erec1: "Oddana energia bierna pojemnościowa faza 1",
			erii1: "Pobrana energia bierna indukcyjna faza 1",
			erei1: "Oddana energia bierna indukcyjna faza 1",
			eric2: "Pobrana energia bierna pojemnościowa faza 2",
			erec2: "Oddana energia bierna pojemnościowa faza 2",
			erii2: "Pobrana energia bierna indukcyjna faza 2",
			erei2: "Oddana energia bierna indukcyjna faza 2",
			eric3: "Pobrana energia bierna pojemnościowa faza 3",
			erec3: "Oddana energia bierna pojemnościowa faza 3",
			erii3: "Pobrana energia bierna indukcyjna faza 3",
			erei3: "Oddana energia bierna indukcyjna faza 3",
			prave1: "Średnia moc bierna faza 1",
			prmax1: "Maksymalna moc bierna faza 1",
			prmin1: "Minimalna moc bierna faza 1",
			prave2: "Średnia moc bierna faza 2",
			prmax2: "Maksymalna moc bierna faza 2",
			prmin2: "Minimalna moc bierna faza 2",
			prave3: "Średnia moc bierna faza 3",
			prmax3: "Maksymalna moc bierna faza 3",
			prmin3: "Minimalna moc bierna faza 3"
		},
		userProfile: {
			account: "Konto",
			title: "Profil użytkownika",
			edit: "Edytuj",
			myProfile: "Mój profil",
			language: "Język",
			email: "Email",
			emailTooltip: "Adres email nie może być edytowany",
			fullname: "Imię nazwisko",
			country: "Kraj",
			timezone: "Strefa czasowa",
			countryTooltip: "Kraj instalacji urządzenia.",
			countryRequired: "Pole Kraj jest wymagane",
			timezoneTooltip: "Strefa czasowa w której zainstalowane jest urządzenie.",
			timezoneRequired: "Strefa czasowa jest wymagana.",
			infoTitleOk: "Wszystko w porządku!",
			infoDescriptionOk: "Nie znaleźliśmy problemów związanych z Twoim kontem.",
			infoTitleWrong: "Potrzebujemy Twojej uwagi",
		},
		languages: {
			english: "Angielski",
			polish: "Polski",
			turkish: "Turecki",
			spanish: "Hiszpański",
		},
		forms: {
			successfullySaved: "Poprawnie zapisano dane.",
			successfullyExported: "Poprawnie wyeksportowano dane",
			errorInSaving: "Nie udało się zapisać danych. Sprawdź formularz.",
			errorInExporting: "Nie udało się wyeksportować danych.",
			submit: "Zatwierdź",
			discard: "Wyczyść",
			ok: "Ok",
			okGotIt: "Ok, zrozumiałem!",
			edit: "Edytuj",
			cancel: "Anuluj",
			save: "Zapisz",
			export: "Eksportuj",
			provideEnergyMeterValue: "Wprowadź wartość licznika",
			provideEnergyMeterValueHint: "Wprowadzona ilość energii będzie wartością początkową do której urządzenie będzie dodawać kolejne odczyty.",
			dateFrom: "Data od",
			dateTo: "Data do",
		},
		deviceOverview: {
			title: "Szczegóły urządzenia",
			edit: "Edytuj",
			name: "Nazwa",
			friendlyName: "Nazwa z urządzenia",
			typeName: "Nazwa typu",
			mac: "Mac",
			modelName: "Nazwa modelu",
			registeredDate: "Data rejestracji",
			modifiedDate: "Data modyfikacji",
			registeredDateTooltip: "Data kiedy urządzenie zostało zarejestowane w systemie",
			modifiedDateTooltip: "Data kiedy urządzenie zmieniło swoje dane",
			nameTooltip: "Nazwa ustalana przez użytkownika, możesz nią zmienić.",
			billingStartDate: "Data rozpoczęcia okresu rozliczeniowego",
			billingNoMonths: "Długość okresu rozliczeniowego w miesiącach",
			defaultTariff: "Taryfa rozliczeniowa urządzenia",
			location: "Lokalizacja",
			notificationsFromDevice: "Powiadomienia PUSH",
			notificationsEnabled: "Włączone",
			notificationsDisabled: "Wyłączone",
			notifyWhenVoltageDrops: "Powiadamiaj o spadku napięciu przy",
			notifyWhenVoltageRises: "Powiadamiaj o przekroczeniu napięcia po",
			notifyWhenTotalCosumptionAbove: "Powiadamiaj o przekroczeniu zużycia energii powyżej",
			disableNotificationsAtNight: "Nie wysyłaj powiadomień w nocy (22:00 - 7:00)",
			notificationInterval: "Wysyłaj powiadomienia nie częściej niż",
			muteNotifications: "Wycisz powiadomienia",
			muteNotificationsInfo: "Powiadomienia nie będą wysyłane z systemu telemetrii. Obejmuje wszystkie typy powiadomień."
		},
		tariff: {
			pageTitle: "Statystyki zużycia energii",
			chceckUsages: "Sprawdź zużycia",
			g11Description: "Podstawowa taryfa roliczenieowa. Jedna stawka za energię elektryczną o każdej porze dnia i nocy.",
			g12Description: "Taryfa dwustrefowa. Dla korzystających z energii elektrycznej głównie w nocy, w szczególności na potrzeby ogrzewania.",
			g12asDescription: "Taryfa dwustrefowa. Dostosowana do celów grzewczych.",
			g12rDescription: "Taryfa dwustrefowa. Podobna do G12, nastawiona jeszcze bardziej na zużycie energii w nocy.",
			g12nDescription: "Taryfa dwustrefowa. Rozliczenie w taryfie dziennej i nocnej z rozszerzoną strefą nocną o niedzielę.",
			g12wDescription: "Taryfa dwustrefowa. Niższa cena prądu w weekend, w nocy i wybranych godzinach dnia.",
			profitCostText: "Orientacyjny zysk/koszt energii ",
			currentConsumption: "Bieżące zużycie",
			showCosts: "Pokaż koszt",
			area1: "Strefa dzienna",
			area2: "Strefa nocna",
			currentUsageDescription: "Zużycie energii z bieżącego miesiąca według taryfy domyślnej",
			attentionInfo: "Prezentowane dane mają charakter symulacyjny i nie mogą być podstawą do potencjalnych roszczeń w stosunku do jakiegokolwiek podmiotu.",
			yourTariff: "Twoja taryfa",
			tariffsTitile: "Taryfy",
			priceArea1: "Cena w strefie pierwszej (dziennej)",
			priceArea2: "Cena w strefie drugiej (nocnej)",
			priceArea3: "Cena w strefie trzeciej",
			priceConst: "Opłata stała",
			priceConstInfo: "Zsumuj wszystkie stałe wartości z swojej faktury za energię i ustaw tą wartość jako stałą opłatę.",
			g11SummaryText: "Podstawowa taryfa dla gospodarstw domowych",
			gxSummaryText: "Zużywasz energię w dwóch strefach: dziennej i nocnej",
			area1_2: "Strefa dzienna/nocna",
			g11DescTitile: "Komfortowa G11",
			g12DescTitile: "Elastyczna G12",
			g12asDescTitile: "Taryfa G12as",
			g12nDescTitile: "Taryfa G12n",
			g12rDescTitile: "Taryfa G12r",
			g12wDescTitile: "Taryfa G12w",
			monday_sunday: "Poniedziałek - niedziela",
			monday_saturday: "Poniedziałek - sobota",
			monday_friday: "Poniedziałek - piątek",
			saturdaySunday: "Sobota, niedziela i święta",
			sundayFeasts: "Niedziela i święta",
			zone: "Strefa",
			wholeDay: "Całodobowe",
			tariffRule: "Zasada taryfy:",
			g11DescRule: "Jedna stawka za energię elektryczną o każdej porze dnia i nocy. Oferta da korzystających z energii elektrycznej głównie w dzień, nie korzystających z energi elektrycznej do celów grzewczych.",
			g12DescRule: "Umożliwia rozlicznie zużytej energii w dwóch strefach czasowych. Oferta dla korzystających z energii elektrycznej głównie w nocy, w szczególności na potrzeby ogrzewania.",
			g12asDescRule: "Taryfa zakłada niższe stawki na energię elektryczną między godziną 22.00 a 6.00, pod warunkiem wykorzystania energii dla celów ogrzewania pomieszczeń lub zasilania samochodu elektrycznego.",
			g12nDescRule: "Grupa dwustrefowa: strefy, dzienna i nocna z rozszerzoną stefą nocną o niedzielę.",
			g12rDescRule: "Grupa dwustrefowa: strefa dzienna i nocna.",
			g12wDescRule: "Oferta dla klientów korzystających z energii elektrycznej w strefie dziennej i nocnej, z rozszerzoną strefą nocną o soboty i niedzielę.",
			cheaper: "tańsza",
			moreExpensive: "droższa",
			nightPeriod: "Okres nocny",
			dailyPeriod: "Okres dzienny",
			southernPeriod: "Okres południowy",
			morningPeriod: "Okres poranny",
			eveningPeriod: "Okres wieczorny",
			selectTariff: "Wybierz taryfę",
			noTariffSelected: "Nie wybrano taryfy",
			compareTariff: "Porównaj taryfy",
			compareTariffDescription: "Możesz porównać swoje zużycia energii elektrycznej względem różnych taryf energetycznych."
		},
		location: {
			indexTitle: "Lokalizacje",
			name: "Nazwa",
			code: "Kod",
			address: "Adres",
			city: "Miasto",
			timezone: "Strefa czasowa",
			energyTariff: "Taryfa energetyczna",
			edit: "Edytuj lokalizację",
			yourLocations: "Twoje lokalizacje",
			newLocationTitle: "Dodaj nową lokalizację",
			availableEnergyTariffs: "Dostępne taryfy energetyczne",
			resetDefaut: "Resetuj",
			restoredDefault: "Przywrócono wartości domyślne",
			successfullyDeleted: "Pomyślnie usunięto lokalizację"
		},
		toasts: {
			success: "Sukces",
			warning: "Ostrzeżenie",
			error: "Błąd",
			info: "Informacja",
			help: "Pomoc",
			weakWiFiSignal: {
				title: "Problemy z połączeniem",
				description: "Siła sygnału WiFi urządzenia Fox jest słaba lub urządzenie jest offline"
			}
		},
		validators: {
			number: "Wprowadź poprawną liczbę",
			min: "Wartość musi być większa bądź równa ",
			max: "Wartość musi być mniejsza bądź równa ",
			dateRange: "Zakres dat jest wymagany",
			parameterMin: "Wybierz conajmniej jeden parametr",
			exportTo: "Wybierz format pliku do eksportu",
			required: "To pole nie może pozostać bez wartości",
			warningLevelGreater: "Wartość ostrzegająca nie może być większa niż wartość przekroczona",
			warningLevelRange: "Wartość ostrzegająca musi być z zakresu 0-50%",
			criticalLevelLess: "Wartość przekroczona musi być większa od wartości ostrzegającej",
			criticalLevelRange: "Wartość przekroczona musi być z zakresu 0-100%",
			comparationNameLength: "Nazwa porównania musi mieć od 3 do 30 znaków",
			selectAtLeastOneParameter: "Wybierz conajmniej jeden parametr do porównania",
			invalidEmail: "Wprowadź poprawny adres email",
			passwordLength: "Hasło musi mieć conajmniej 4 znaki",
		},
		exportData: {
			title: "Eksportuj dane",
			parameters: "Parametry",
			parametersHint: "Wybierz parametry do eksportu",
			dateRange: "Wybierz zakres dat",
			customFileName: "Własna nazwa pliku",
			customFileNameHint: "Wpisz własną nazwę pliku lub pozostaw puste pole",
			exportAllParams: "Eksportuj wszystkie dostępne parametry urządzenia",
			exportTo: "Eksportuj do pliku",
			exportUnavailableTitle: "Eksport niedostępny",
			exportUnavailableDesc: "Wykryliśmy wzmożoną ilość zapytań do serwera. Eksportowanie danych jest chwilowo niedostępne. Spróbuj ponownie później.",
			exportInBackround: "Zlecono eksport danych. Poinformujemy Cię kiedy plik będzie gotowy.",
			exportToCsv: "Eksportuj do CSV",
			exportToPdf: "Eksportuj do PDF",
			print: "Drukuj",
		},
		times: {
			min15: "15 min.",
			min30: "30 min.",
			min60: "1 godzina",
			min1440: "24 godziny"
		},
		analytics: {
			selectOperation: "Wybierz akcję",
			dailyHeatmap: "Dzienne zużycie energii (heatmap)",
			monthlyHeatmap: "Miesięczne zużycie energii (heatmap)",
			weeklyHeatmap: "Tygodniowe zużycie energii (heatmap)",
			yearlyHeatmap: "Roczne zużycie energii (heatmap)",
			selectDevices: "Wybierz urządzenia",
			selectDateRange: "Wybierz zakres czasu",
			sumCmpDesc: "Sumy zużycia energii",
			compareTitle: "Analiza porównawcza",
			compareDescription: "Porównaj parametry urządzeń w zakresie wybranych akcji lub zdefiniuj własną",
			noData: "Brak danych",
			analyze: "Analizuj",
			datetimeRangeConsumption: "Okresowe zużycie energii (tabela)",
			dateTimeEnergyConsumption: "Zużycie energii w okresie",
		},
		comparation: {
			newComparation: "Nowe porównanie",
			shortDesccription: "System umożliwia analizę i porównanie danych pomiarowych (np. napięcie, prąd, moc) dla każdej fazy osobno oraz w konfiguracji sumarycznej",
			name: "Nazwa porównania",
			namePlaceholder: "Wprowadź nazwę porównania",
			selectParametrsTitle: "Wybierz parametry do porównania",
			showGroupedParametes: "Wyświetlaj parametry grupowo (na jednym wykresie), tam gdzie jest taka możliwość",
			deleteCard: "Czy na pewno chcesz usunąć kartę o nazwie",
			deleteCardDesc: "Ta operacja jest nieodwracalna i usunie wszystkie dane - upewnij się, że chcesz to zrobić.",
		},
		actions: {
			compare: "Porównaj",
			cancel: "Anuluj",
			delete: "Usuń",
			back: "Wróć",
			close: "Zamknij",
			save: "Zapisz",
		},
		menu: {
			analytics: "Analityka",
			locations: "Lokalizacje",
			tarrifs: "Taryfy",
			readouts: "Odczyty urządzenia",
			settings: "Ustawienia",
			signOut: "Wyloguj",
			deviceList: "Lista urządzeń",
			navigation: "Nawigacja",
		},
		providedBy: "Dostarczone przez",
		manufacturer: "F&F Filipowski Sp. k.",
		pleaseWait: "Proszę czekać...",
		dashboard: "Dashboard",
		authentication: "Autentykacja",
		signIn: "Zaloguj",
		signUp: "Zarejestruj",
		signOut: "Wyloguj",
		passwordReset: "Resetuj hasło",
		error404: "Wygląda na to, że nic tutaj nie ma",
		error500: "Wystąpił wewnętrzny błąd serwera. Skontaktuj się z administratorem",
		daily: "Dzienne",
		monthly: "Miesięczne",
		yearly: "Roczne",
		total: "Całkowite",
		select: "Wybierz",
		noData: "Brak danych",
		add: "Dodaj",
		deletePrompt: "Potwierdź operację usunięcia danych. Czy jesteś pewien?",
		yes: "Tak",
		no: "Nie",
		edit: "Edytuj",
		attention: "Uwaga",
		date: "Data",
		selectDate: "Wybierz datę",
		selectDateGlobalDesc: "Wybrana data będzie zastosowana do wszystkich wykresów",
		energyTableView: "Widok tabeli",
		lp: "Lp.",
		value: "Wartość",
		unit: "Jednostka",
		on: "Włączony",
		off: "Wyłączony",
		temperature: "Temperatura",
		close: "Zamknij",
		dataRangeOverflow: "Zbyt duży zakres dat! Widok obsługuje dane tylko z jednego dnia.",
		selectInterestedDate: "Wybierz interesujący Cię przedział czasu",
		delete: "Usuń",
		phase: "Faza",
		sum: "Suma",
		device: "Urządzenie",
		changesSavedSuccessfully: "Zmiany zostały zapisane poprawnie.",
	},
	es: {
		auth: {
			welcome: "Bienvenido a",
			email: "Correo electrónico",
			emailPlaceholder: "Introduce tu correo electrónico",
			password: "Contraseña",
			passwordPlaceholder: "Introduce tu contraseña",
			rememberMe: "Recuérdame",
			showDemo: "Mostrar demo",
			signIn: "Iniciar sesión",
			manufacturer: "Fabricante polaco de automatización doméstica e industrial",
			titlep1: "Control",
			titlep2: "total",
			titlep3: "sobre la energía en casa y en la empresa",
		},
		signInView: {
			signInTitle: "Inicia sesión en el sistema Telemetry",
			email: "Correo electrónico",
			password: "Contraseña",
			continue: "Continuar",
			successfull: "Has iniciado sesión correctamente.",
			failed: "Inténtalo de nuevo.",
			confirm: "Ok",
			rememberMe: "Recuérdame",
			token: "Token",
			params: "Parámetros",
			showDemo: "Ver demo"
		},
		deviceListWidget: {
			title: "Dispositivos registrados",
			total: "Cantidad",
			dName: "Nombre",
			dModel: "Modelo",
			dStatus: "Estado",
			dActions: "Acciones",
			location: "Ubicación",
			tariff: "Tarifa",
		},
		deviceDetailsView: {
			currentVoltage: "Voltaje actual",
			current: "Corriente actual",
			currentPower: "Potencia actual",
			voltageTitle: "Voltaje",
			powerTitle: "Potencia",
			currentTitle: "Corriente",
			energyTitle: "Energía activa",
			energyReactiveTitle: "Energía reactiva",
			energyTitleExport: "Energía exportada",
			energyTitleImport: "Energía consumida",
			energyReactiveExportTitle: "Energía reactiva exportada",
			energyReactiveImportTitle: "Energía reactiva consumida",
			voltageDescription:
				"Valor de voltaje con niveles mínimo y máximo registrados en el intervalo de tiempo.",
			currentDescription:
				"Valor de corriente con niveles mínimo y máximo registrados en el intervalo de tiempo.",
			powerDescription:
				"Valor de potencia con niveles mínimo y máximo registrados en el intervalo de tiempo.",
			energyDescription:
				"Valor de energía activa consumida y exportada, registrado en el intervalo de tiempo.",
			energy3Description:
				"Valor de energía activa consumida y exportada, sumada de las 3 fases, registrado en el intervalo de tiempo.",
			energyReactiveDescription:
				"Valor de energía reactiva consumida y exportada, registrado en el intervalo de tiempo.",
			phase1: "Fase 1",
			phase2: "Fase 2",
			phase3: "Fase 3",
			summary: "Resumen",
			phase1dsc: "Valores de la fase 1",
			phase2dsc: "Valores de la fase 2",
			phase3dsc: "Valores de la fase 3",
			summarydsc: "Valores agregados de las 3 fases.",
			power3phasesDescription: "Suma de potencia de las 3 fases registrada en el intervalo de tiempo.",
			voltage3phasesDescription: "Valor de voltaje de cada fase registrado en el intervalo de tiempo.",
			current3phasesDescription: "Valor de corriente de cada fase registrado en el intervalo de tiempo.",
			energy3phasesImportDescription:
				"Suma de energía consumida de las 3 fases registrada en el intervalo de tiempo.",
			energy3phasesExportDescription:
				"Suma de energía exportada de las 3 fases registrada en el intervalo de tiempo.",
			energyReactive3phasesImportDescription:
				"Suma de energía reactiva consumida de las 3 fases registrada en el intervalo de tiempo.",
			energyReactive3phasesExportDescription:
				"Suma de energía reactiva exportada de las 3 fases registrada en el intervalo de tiempo.",
			energyConsumption: "Consumo de energía",
			fromBillingPeriod: "Del periodo de facturación",
			selectBillingPeriod: "Selecciona el periodo de facturación",
			noBillingPeriod: "No hay periodos de facturación definidos.",
			active: "Activa",
			reactive: "Reactiva",
			volt: "Voltios",
			amper: "Amperios",
			watt: "Vatios",
			outPower: "exportada",
			details: "Detalles",
			energyProductionTitle: "Producción de energía",
			carbonEmissionHint: "Tu huella de carbono es menor. Gracias por cuidar nuestro planeta.",
			energyProductionDescription: "Valor de la energía exportada registrada en el intervalo de tiempo",
			solarPowerDescription: "Valor de potencia registrado en el intervalo de tiempo.",
			energyBalance: "Balance de energía",
			energyBalanceDescription: "Balance de energía activa consumida y exportada registrada en el intervalo de tiempo.",
			selectView: "Selecciona la vista",
			relayState: "Estado del relé",
			energyActiveSelectorDescription: "La energía activa es la parte de la energía eléctrica que realmente se convierte en trabajo, por ejemplo calor, luz o movimiento, y se mide en kilovatios-hora (kWh).",
			energyReactiveSelectorDescription: "La energía reactiva es el componente de la energía eléctrica que no realiza trabajo útil, pero es necesario para generar el campo magnético en dispositivos como motores o transformadores, y se mide en kilovoltamperios-hora reactivos (kVArh).",
			eneryToday: "Hoy",
			monthly: "Este mes",
			yearly: "Este año",
			total: "Desde el inicio",
			thermoTitle: "Termostato",
			thermoDescription: "Valores registrados del estado de la salida, la temperatura medida y la configurada.",
			relayOutputEnable: "Salida activada",
			relayOutputDisable: "Salida desactivada",
			currentTemperature: "Temperatura actual",
			setTemperature: "Temperatura configurada",
			thermoAlarmDesc: "El estado del dispositivo se supervisa continuamente y los datos se muestran en tiempo real",
			today: "hoy",
			production: "Producción",
			consumption: "Consumo",
			energyMeterMenuTitle: "Mostrar energía teniendo en cuenta el estado del contador del proveedor",
			energyMeterResetDefaultsHint: "No tengas en cuenta los datos anteriores al mostrar el consumo de energía (restaurar la configuración predeterminada).",
			energyMeterValueSavedSuccessfully: "Los datos del contador de energía se guardaron correctamente",
			energyMeterValueSavedError: "No se pudieron guardar los datos del contador de energía",
			limitValuesTitle: "Valores límite",
			limitValuesVoltageDesc: "Establece los valores límite como porcentaje del valor nominal de 230 V",
			limitWarningValue: "Valor de advertencia",
			limitWarnigDesc: "Valor que se acerca al límite.",
			limitCriticalValue: "Valor crítico",
			limitCriticalDesc: "Valor fuera del rango seguro.",
			limitsValuesSavedSuccessfully: "Los valores límite se guardaron correctamente",
			limitsValuesSavedError: "No se pudieron guardar los valores límite",
			deviceDeletingTitle: "¿Seguro que quieres eliminar este dispositivo?",
			deviceDeletingPrompt: "Esta operación es irreversible y eliminará todos los datos relacionados con este dispositivo",
			deviceDeleted: "El dispositivo se eliminó correctamente",
			errorDeletingDevice: "No se pudo eliminar el dispositivo",
			followedTariff: "Según la tarifa",
			comparations: {
				vaveTitle: "Voltaje de fase",
				vaveDescription: "El gráfico muestra los valores de voltaje de cada fase para el intervalo de tiempo seleccionado.",
				iaveTitle: "Corriente de fase",
				iaveDescription: "El gráfico muestra los valores de corriente de cada fase para el intervalo de tiempo seleccionado.",
				paveTitle: "Potencia",
				paveDescription: "El gráfico muestra el valor de potencia para la fase y el intervalo de tiempo seleccionados.",
				power3phasesTitle: "Suma de potencia",
				power3phasesDescription: "El gráfico muestra la suma de potencia de las tres fases para el intervalo de tiempo seleccionado.",
				ienergy3phasesTitle: "Suma de energía consumida y exportada",
				ienergy3phasesDescription: "El gráfico muestra la suma de energía consumida y exportada de las tres fases para el intervalo de tiempo seleccionado.",
				oenergy3phasesTitle: "Balance de energía",
				oenergy3phasesDescription: "El gráfico muestra el balance de energía, es decir, la diferencia entre la energía exportada y la consumida de las tres fases para el intervalo de tiempo seleccionado.",
				"pave;pmin;pmaxTitle": "Potencia: media, mín., máx.",
				"pave;pmin;pmaxDescription": "El gráfico muestra la potencia media, mínima y máxima para la fase y el intervalo de tiempo seleccionados.",
				"vave;vmin;vmaxTitle": "Voltaje: media, mín., máx.",
				"vave;vmin;vmaxDescription": "El gráfico muestra el voltaje medio, mínimo y máximo para la fase y el intervalo de tiempo seleccionados.",
				"iave;imin;imaxTitle": "Corriente: media, mín., máx.",
				"iave;imin;imaxDescription": "El gráfico muestra la corriente media, mínima y máxima para la fase y el intervalo de tiempo seleccionados.",
				ioenergyTitle: "Energía activa: consumida y exportada",
				ioenergyDescription: "El gráfico muestra la energía activa consumida y exportada para la fase y el intervalo de tiempo seleccionados.",
				renergyTitle: "Energía reactiva: consumida y exportada",
				renergyDescription: "El gráfico muestra la energía reactiva consumida y exportada para la fase y el intervalo de tiempo seleccionados.",
				compatarationSavingErrorTitle: "Se produjo un error al guardar los datos",
				compatarationSavingErrorDesc: "Tus comparaciones no se guardaron en el servidor. Después de actualizar la página, la vista volverá al último estado guardado.",
				cenergyTitle: "Energía reactiva capacitiva - consumida y exportada",
  				cenergyDescription: "El gráfico muestra la energía reactiva capacitiva consumida y exportada para el rango de tiempo y la fase seleccionados.",
  				indenergyTitle: "Energía reactiva inductiva - consumida y exportada",
  				indenergyDescription: "El gráfico muestra la energía reactiva inductiva consumida y exportada para el rango de tiempo y la fase seleccionados."
			},
			powerTitleAvg: "Potencia media, mín., máx.",
			voltageTitleAvg: "Voltaje medio, mín., máx.",
			currentTitleAvg: "Corriente media, mín., máx.",
			provideConsumption: "Introduce el consumo",
			editConsumption: "Editar consumo",
		},
		alarms: {
			noWarnings: "No hay advertencias",
		},
		chartsDropdowns: {
			chartOptions: "Opciones del gráfico",
			date: "Selecciona la fecha",
			dateRange: "Selecciona el intervalo de fechas",
			simpleChartDateHint: "Los datos del gráfico se mostrarán para el intervalo: fecha seleccionada más 24 horas",
			reset: "Restablecer",
			apply: "Aplicar",
		},
		pagesTitle: {
			dashboard: "Panel",
			devicedetails: "Información del dispositivo",
			deviceData: "Lecturas del dispositivo",
			deviceEdit: "Editar datos del dispositivo",
			locationIndex: "Ubicaciones",
			locationDetails: "Lista de ubicaciones",
			tariffsBalance: "Consumo de energía según la tarifa",
			analytics: "Análisis comparativo"
		},
		time: {
			hour: "Hora",
			minute: "Minuto",
			seconds: "Segundos",
			day: "Día",
			month: "Mes",
			week: "Semana",
			year: "Año",
			range: "Intervalo de tiempo"
		},
		notifications: {
			title: "Notificaciones",
			events: "Eventos",
			empty: "No hay notificaciones nuevas",
			showAll: "Ver todas",
		},
		themeMenu: {
			title: "Tema",
			light: "Claro",
			dark: "Oscuro",
			system: "Sistema"
		},
		devParameters: {
			pave1: "Potencia L1",
			pave2: "Potencia L2",
			pave3: "Potencia L3",
			pmax1: "Potencia L1 - máx.",
			pmax2: "Potencia L2 - máx.",
			pmax3: "Potencia L3 - máx.",
			pmin1: "Potencia L1 - mín.",
			pmin2: "Potencia L2 - mín.",
			pmin3: "Potencia L3 - mín.",
			vave1: "Voltaje L1",
			vave2: "Voltaje L2",
			vave3: "Voltaje L3",
			vmax1: "Voltaje L1 - máx.",
			vmax2: "Voltaje L2 - máx.",
			vmax3: "Voltaje L3 - máx.",
			vmin1: "Voltaje L1 - mín.",
			vmin2: "Voltaje L2 - mín.",
			vmin3: "Voltaje L3 - mín.",
			iave1: "Corriente L1",
			iave2: "Corriente L2",
			iave3: "Corriente L3",
			imax1: "Corriente L1 - máx.",
			imax2: "Corriente L2 - máx.",
			imax3: "Corriente L3 - máx.",
			imin1: "Corriente L1 - mín.",
			imin2: "Corriente L2 - mín.",
			imin3: "Corriente L3 - mín.",
			eai1: "Energía consumida L1",
			eai2: "Energía consumida L2",
			eai3: "Energía consumida L3",
			eae1: "Energía exportada L1",
			eae2: "Energía exportada L2",
			eae3: "Energía exportada L3",
			eri1: "Energía reactiva consumida L1",
			eri2: "Energía reactiva consumida L2",
			eri3: "Energía reactiva consumida L3",
			ere1: "Energía reactiva exportada L1",
			ere2: "Energía reactiva exportada L2",
			ere3: "Energía reactiva exportada L3",
			pfave1: "Factor de potencia L1",
			pfave2: "Factor de potencia L2",
			pfave3: "Factor de potencia L3",
			pfmax1: "Factor de potencia L1 - máx.",
			pfmax2: "Factor de potencia L2 - máx.",
			pfmax3: "Factor de potencia L3 - máx.",
			pfmin1: "Factor de potencia L1 - mín.",
			pfmin2: "Factor de potencia L2 - mín.",
			pfmin3: "Factor de potencia L3 - mín.",
			energy3phases: "Energía total",
			renergy3phases: "Energía reactiva total",
			power3phases: "Suma de potencia",
			energy3phases_export: "Energía total exportada",
			energy3phases_import: "Energía total consumida",
			renergy3phases_export: "Energía reactiva total exportada",
			renergy3phases_import: "Energía reactiva total consumida",
			frq1: "Frecuencia",
			vdc1: "Voltaje DC1",
			vdc2: "Voltaje DC2",
			vdc3: "Voltaje DC3",
			idc1: "Corriente DC1",
			idc2: "Corriente DC2",
			alarm: "Alarma",
			balance: "Balance",
			tempmain: "Temperatura medida",
			tempset: "Temperatura configurada",
			rel1: "Salida del relé",
		},
		userProfile: {
			account: "Cuenta",
			title: "Perfil del usuario",
			edit: "Editar",
			myProfile: "Mi perfil",
			language: "Idioma",
			email: "Correo electrónico",
			emailTooltip: "La dirección de correo electrónico no se puede editar",
			fullname: "Nombre y apellidos",
			country: "País",
			timezone: "Zona horaria",
			countryTooltip: "País donde está instalado el dispositivo.",
			countryRequired: "El campo País es obligatorio",
			timezoneTooltip: "Zona horaria en la que está instalado el dispositivo.",
			timezoneRequired: "La zona horaria es obligatoria.",
			infoTitleOk: "Todo está bien",
			infoDescriptionOk: "No encontramos problemas relacionados con tu cuenta.",
			infoTitleWrong: "Necesitamos tu atención",
		},
		languages: {
			english: "Inglés",
			polish: "Polaco",
			turkish: "Turco",
			spanish: "Español",
		},
		forms: {
			successfullySaved: "Los datos se guardaron correctamente.",
			successfullyExported: "Los datos se exportaron correctamente",
			errorInSaving: "No se pudieron guardar los datos. Revisa el formulario.",
			errorInExporting: "No se pudieron exportar los datos.",
			submit: "Enviar",
			discard: "Limpiar",
			ok: "Ok",
			okGotIt: "Ok, entendido",
			edit: "Editar",
			cancel: "Cancelar",
			save: "Guardar",
			export: "Exportar",
			provideEnergyMeterValue: "Introduce el valor del contador",
			provideEnergyMeterValueHint: "La cantidad de energía introducida será el valor inicial al que el dispositivo añadirá las lecturas posteriores.",
			dateFrom: "Fecha desde",
			dateTo: "Fecha hasta",
		},
		deviceOverview: {
			title: "Detalles del dispositivo",
			edit: "Editar",
			name: "Nombre",
			friendlyName: "Nombre del dispositivo",
			typeName: "Nombre del tipo",
			mac: "Mac",
			modelName: "Nombre del modelo",
			registeredDate: "Fecha de registro",
			modifiedDate: "Fecha de modificación",
			registeredDateTooltip: "Fecha en la que el dispositivo fue registrado en el sistema",
			modifiedDateTooltip: "Fecha en la que el dispositivo cambió sus datos",
			nameTooltip: "Nombre definido por el usuario; puedes cambiarlo.",
			billingStartDate: "Fecha de inicio del periodo de facturación",
			billingNoMonths: "Duración del periodo de facturación en meses",
			defaultTariff: "Tarifa de facturación del dispositivo",
			location: "Ubicación",
			notificationsFromDevice: "Notificaciones PUSH",
			notificationsEnabled: "Activadas",
			notificationsDisabled: "Desactivadas",
			notifyWhenVoltageDrops: "Notificar cuando el voltaje baje a",
			notifyWhenVoltageRises: "Notificar cuando el voltaje supere",
			notifyWhenTotalCosumptionAbove: "Notificar cuando el consumo de energía supere",
			disableNotificationsAtNight: "No enviar notificaciones por la noche (22:00 - 7:00)",
			notificationInterval: "Enviar notificaciones no más frecuentes que",
			muteNotifications: "Silenciar notificaciones",
			muteNotificationsInfo: "Las notificaciones no se enviarán desde el sistema de telemetría. Incluye todos los tipos de notificaciones."
		},
		tariff: {
			pageTitle: "Estadísticas del consumo de energía",
			chceckUsages: "Comprobar consumos",
			g11Description: "Tarifa básica de facturación. Una única tarifa para la electricidad a cualquier hora del día y de la noche.",
			g12Description: "Tarifa de dos franjas. Para quienes usan la electricidad principalmente por la noche, en particular para calefacción.",
			g12asDescription: "Tarifa de dos franjas. Adaptada a fines de calefacción.",
			g12rDescription: "Tarifa de dos franjas. Similar a G12, aún más orientada al consumo nocturno.",
			g12nDescription: "Tarifa de dos franjas. Liquidación en tarifa diurna y nocturna con franja nocturna ampliada al domingo.",
			g12wDescription: "Tarifa de dos franjas. Precio más bajo de la electricidad los fines de semana, por la noche y en horas seleccionadas del día.",
			profitCostText: "Beneficio/coste estimado de la energía ",
			currentConsumption: "Consumo actual",
			showCosts: "Mostrar coste",
			area1: "Franja diurna",
			area2: "Franja nocturna",
			currentUsageDescription: "Consumo de energía del mes actual según la tarifa predeterminada",
			attentionInfo: "Los datos presentados son de carácter simulado y no pueden constituir base para posibles reclamaciones frente a ninguna entidad.",
			yourTariff: "Tu tarifa",
			tariffsTitile: "Tarifas",
			priceArea1: "Precio en la primera franja (diurna)",
			priceArea2: "Precio en la segunda franja (nocturna)",
			priceArea3: "Precio en la tercera franja",
			priceConst: "Tarifa fija",
			priceConstInfo: "Suma todos los valores fijos de tu factura de energía y establece ese valor como tarifa fija.",
			g11SummaryText: "Tarifa básica para hogares",
			gxSummaryText: "Consumes energía en dos franjas: diurna y nocturna",
			area1_2: "Franja diurna/nocturna",
			g11DescTitile: "Cómoda G11",
			g12DescTitile: "Flexible G12",
			g12asDescTitile: "Tarifa G12as",
			g12nDescTitile: "Tarifa G12n",
			g12rDescTitile: "Tarifa G12r",
			g12wDescTitile: "Tarifa G12w",
			monday_sunday: "Lunes - domingo",
			monday_saturday: "Lunes - sábado",
			monday_friday: "Lunes - viernes",
			saturdaySunday: "Sábado, domingo y festivos",
			sundayFeasts: "Domingo y festivos",
			zone: "Franja",
			wholeDay: "Todo el día",
			tariffRule: "Regla de la tarifa:",
			g11DescRule: "Una única tarifa para la electricidad a cualquier hora del día y de la noche. Oferta para quienes usan la electricidad principalmente durante el día y no la utilizan con fines de calefacción.",
			g12DescRule: "Permite liquidar la energía consumida en dos franjas horarias. Oferta para quienes usan la electricidad principalmente por la noche, especialmente con fines de calefacción.",
			g12asDescRule: "La tarifa prevé precios más bajos de la electricidad entre las 22:00 y las 6:00, siempre que la energía se use para calefacción o para cargar un coche eléctrico.",
			g12nDescRule: "Grupo de dos franjas: diurna y nocturna, con franja nocturna ampliada al domingo.",
			g12rDescRule: "Grupo de dos franjas: franja diurna y nocturna.",
			g12wDescRule: "Oferta para clientes que usan la electricidad en franjas diurnas y nocturnas, con franja nocturna ampliada a sábados y domingos.",
			cheaper: "más barata",
			moreExpensive: "más cara",
			nightPeriod: "Periodo nocturno",
			dailyPeriod: "Periodo diurno",
			southernPeriod: "Periodo del mediodía",
			morningPeriod: "Periodo matutino",
			eveningPeriod: "Periodo vespertino",
			selectTariff: "Selecciona una tarifa",
			noTariffSelected: "No se ha seleccionado ninguna tarifa",
			compareTariff: "Comparar tarifas",
			compareTariffDescription: "Puedes comparar tu consumo de electricidad con distintas tarifas energéticas."
		},
		location: {
			indexTitle: "Ubicaciones",
			name: "Nombre",
			code: "Código",
			address: "Dirección",
			city: "Ciudad",
			timezone: "Zona horaria",
			energyTariff: "Tarifa energética",
			edit: "Editar ubicación",
			yourLocations: "Tus ubicaciones",
			newLocationTitle: "Añadir nueva ubicación",
			availableEnergyTariffs: "Tarifas energéticas disponibles",
			resetDefaut: "Restablecer",
			restoredDefault: "Se restauraron los valores predeterminados",
			successfullyDeleted: "La ubicación se eliminó correctamente"
		},
		toasts: {
			success: "Éxito",
			warning: "Advertencia",
			error: "Error",
			info: "Información",
			help: "Ayuda",
			weakWiFiSignal: {
				title: "Problemas de conexión",
				description: "La señal WiFi del dispositivo Fox es débil o el dispositivo está sin conexión"
			}
		},
		validators: {
			number: "Introduce un número válido",
			min: "El valor debe ser mayor o igual que ",
			max: "El valor debe ser menor o igual que ",
			dateRange: "El intervalo de fechas es obligatorio",
			parameterMin: "Selecciona al menos un parámetro",
			exportTo: "Selecciona el formato del archivo para exportar",
			required: "Este campo no puede quedar vacío",
			warningLevelGreater: "El valor de advertencia no puede ser mayor que el valor crítico",
			warningLevelRange: "El valor de advertencia debe estar en el rango 0-50%",
			criticalLevelLess: "El valor crítico debe ser mayor que el valor de advertencia",
			criticalLevelRange: "El valor crítico debe estar en el rango 0-100%",
			comparationNameLength: "El nombre de la comparación debe tener entre 3 y 30 caracteres",
			selectAtLeastOneParameter: "Selecciona al menos un parámetro para comparar",
			invalidEmail: "Introduce una dirección de correo electrónico válida",
			passwordLength: "La contraseña debe tener al menos 4 caracteres",
		},
		exportData: {
			title: "Exportar datos",
			parameters: "Parámetros",
			parametersHint: "Selecciona los parámetros para exportar",
			dateRange: "Selecciona el intervalo de fechas",
			customFileName: "Nombre de archivo personalizado",
			customFileNameHint: "Escribe un nombre de archivo personalizado o deja el campo vacío",
			exportAllParams: "Exportar todos los parámetros disponibles del dispositivo",
			exportTo: "Exportar a archivo",
			exportUnavailableTitle: "Exportación no disponible",
			exportUnavailableDesc: "Hemos detectado un aumento de solicitudes al servidor. La exportación de datos no está disponible temporalmente. Inténtalo más tarde.",
			exportInBackround: "Se ha solicitado la exportación de datos. Te informaremos cuando el archivo esté listo.",
			exportToCsv: "Exportar a CSV",
			exportToPdf: "Exportar a PDF",
			print: "Imprimir",
		},
		times: {
			min15: "15 min.",
			min30: "30 min.",
			min60: "1 hora",
			min1440: "24 horas"
		},
		analytics: {
			selectOperation: "Selecciona una acción",
			dailyHeatmap: "Consumo diario de energía (heatmap)",
			monthlyHeatmap: "Consumo mensual de energía (heatmap)",
			weeklyHeatmap: "Consumo semanal de energía (heatmap)",
			yearlyHeatmap: "Consumo anual de energía (heatmap)",
			selectDevices: "Selecciona dispositivos",
			selectDateRange: "Selecciona el intervalo de tiempo",
			sumCmpDesc: "Suma del consumo de energía",
			compareTitle: "Análisis comparativo",
			compareDescription: "Compara los parámetros de los dispositivos según las acciones seleccionadas o define la tuya propia",
			noData: "Sin datos",
			analyze: "Analizar",
			datetimeRangeConsumption: "Consumo de energía por periodo (tabla)",
			dateTimeEnergyConsumption: "Consumo de energía en el periodo",
		},
		comparation: {
			newComparation: "Nueva comparación",
			shortDesccription: "El sistema permite analizar y comparar datos de medición, por ejemplo voltaje, corriente o potencia, para cada fase por separado y también en configuración agregada",
			name: "Nombre de la comparación",
			namePlaceholder: "Introduce el nombre de la comparación",
			selectParametrsTitle: "Selecciona los parámetros para comparar",
			showGroupedParametes: "Mostrar parámetros agrupados (en un solo gráfico) cuando sea posible",
			deleteCard: "¿Seguro que quieres eliminar la pestaña llamada",
			deleteCardDesc: "Esta operación es irreversible y eliminará todos los datos. Asegúrate de que quieres hacerlo.",
		},
		actions: {
			compare: "Comparar",
			cancel: "Cancelar",
			delete: "Eliminar",
			back: "Volver",
			close: "Cerrar",
			save: "Guardar",
		},
		menu: {
			analytics: "Analítica",
			locations: "Ubicaciones",
			tarrifs: "Tarifas",
			readouts: "Lecturas del dispositivo",
			settings: "Configuración",
			signOut: "Cerrar sesión",
			deviceList: "Lista de dispositivos",
			navigation: "Navegación",
		},
		providedBy: "Proporcionado por",
		manufacturer: "F&F Filipowski Sp. k.",
		pleaseWait: "Por favor, espera...",
		dashboard: "Panel",
		authentication: "Autenticación",
		signIn: "Iniciar sesión",
		signUp: "Registrarse",
		signOut: "Cerrar sesión",
		passwordReset: "Restablecer contraseña",
		error404: "Parece que aquí no hay nada",
		error500: "Se ha producido un error interno del servidor. Ponte en contacto con el administrador",
		daily: "Diario",
		monthly: "Mensual",
		yearly: "Anual",
		total: "Total",
		select: "Seleccionar",
		noData: "Sin datos",
		add: "Añadir",
		deletePrompt: "Confirma la operación de eliminación de datos. ¿Estás seguro?",
		yes: "Sí",
		no: "No",
		edit: "Editar",
		attention: "Atención",
		date: "Fecha",
		selectDate: "Selecciona la fecha",
		selectDateGlobalDesc: "La fecha seleccionada se aplicará a todos los gráficos",
		energyTableView: "Vista de tabla",
		lp: "N.º",
		value: "Valor",
		unit: "Unidad",
		on: "Encendido",
		off: "Apagado",
		temperature: "Temperatura",
		close: "Cerrar",
		dataRangeOverflow: "Intervalo de fechas demasiado grande. La vista solo admite datos de un día.",
		selectInterestedDate: "Selecciona el intervalo de tiempo que te interesa",
		delete: "Eliminar",
		phase: "Fase",
		sum: "Suma",
		device: "Dispositivo",
		changesSavedSuccessfully: "Los cambios se han guardado correctamente.",
	},
	// do translations below, change only strings without keys :)
	tr: {
		signInView: {
			signInTitle: "Telemetry Sistemine Giriş Yapın",
			email: "E-posta",
			password: "Şifre",
			continue: "devam et",
			successfull: "Başarılı bir şekilde giriş yaptınız.",
			failed: "Tekrar deneyin!",
			confirm: "Anlaşıldı!",
			rememberMe: "Beni hatırla",
			token: "Token",
			params: "Parametreler",
			showDemo: "Show demo"
		},
		deviceListWidget: {
			title: "Kayıtlı cihazlar",
			total: "Toplam",
			dName: "İsim",
			dModel: "Model",
			dStatus: "Durum",
			dActions: "Aktiviteler",
			location: "Location",
			tariff: "Tarife",
		},
		deviceDetailsView: {
			currentVoltage: "Voltaj",
			current: "Akım",
			currentPower: "Güç",
			voltageTitle: "Voltaj",
			powerTitle: "Güç",
			energyTitle: "Aktif Enerji",
			energyReactiveTitle: "Reaktif enerji",
			energyTitleExport: "Verilen Aktif Enerji",
			energyTitleImport: "Harcanan Aktif Enerji",
			energyReactiveExportTitle: "Verilen Reaktif Enerji",
			energyReactiveImportTitle: "Harcanan Reaktif Enerji",
			voltageDescription:
				"Zaman aralığında yakalanan minimum ve maksimum Voltaj değerlerini gösterir.",
			currentDescription:
				"Zaman aralığında yakalanan minimum ve maksimum Akım değerlerini gösterir.",
			powerDescription:
				"Zaman aralığında yakalanan minimum ve maksimum Güç değerlerini gösterir.",
			energyDescription:
				"Zaman aralığında yakalanan minimum ve maksimum Tüketilen Enerji değerlerini gösterir.",
			energy3Description:
				"Wartość energii czynnej pobranej i oddanej (zsumowna z 3 faz), zarejestrowana w przedziale czasu.",
			energyReactiveDescription:
				"Zaman aralığında yakalanan minimum ve maksimum Reaktif Enerji değerlerini gösterir.",
			phase1: "Faz 1",
			phase2: "Faz 2",
			phase3: "Faz 3",
			summary: "Özet",
			phase1dsc: "Faz 1 verisi",
			phase2dsc: "Faz 2 verisi",
			phase3dsc: "Faz 3 verisi",
			summarydsc: "3 faz verileri",
			power3phasesDescription: "Zaman aralığında yakalanan Toplam güç değerlerini gösterir.",
			voltage3phasesDescription: "Zaman aralığında yakalanan Faz Voltaj değerini gösterir.",
			current3phasesDescription: "Zaman aralığında yakalanan Faz Akım değerini gösterir.",
			energy3phasesDescription:
				"Zaman aralığında Toplam Aktif enerji ve her fazın Aktif Enerji değerlerini gösterir.",
			energyReactive3phasesDescription:
				"Zaman aralığında Toplam Reaktif enerji değerini gösterir.",
			energy3phasesImportDescription:
				"Zaman aralığında Alına Toplam Aktif enerji değerini gösterir.",
			energy3phasesExportDescription:
				"Zaman aralığında Verilen Toplam Aktif enerji değerini gösterir.",
			energyReactive3phasesImportDescription:
				"Zaman aralığında Alına Toplam Reaktif enerji değerini gösterir.",
			energyReactive3phasesExportDescription:
				"Zaman aralığındaki Verilen Toplam Reaktif enerji değerini gösterir.",
			energyConsumption: "Enerji tüketimi",
			fromBillingPeriod: "Faturalama periyodu",
			selectBillingPeriod: "Faturalama periyodu seçin",
			active: "Aktif",
			reactive: "Reaktif",
			volt: "V",
			amper: "A",
			watt: "W",
			outPower: "verilen",
			details: "Daha fazla",
			energyProductionTitle: "Energy production",
			carbonEmissionHint: "Your carbon emission is less. Thank you!",
			energyProductionDescription: "Shows given away active energy captured in time range.",
			solarPowerDescription: "Shows power value captured in time range.",
			energyBalance: "Balance",
			energyBalanceDescription: "Balance of active energy imported and exported, recorded in a time interval.",
			selectView: "Select view"
		},
		chartsDropdowns: {
			chartOptions: "Grafik seçeneği",
			date: "Tarih",
			dateRange: "Tarih aralığı",
			simpleChartDateHint: "Seçilen tarihten sonraki ilk 24 saat verileri görüntülenecek.",
			reset: "Sıfırla",
			apply: "Uygula",
		},
		pagesTitle: {
			dashboard: "Gösterge Paneli",
			devicedetails: "Cihaz hakkında",
			deviceData: "Cihaz verileri",
			locationIndex: "Lokasyonlar",
		},
		time: {
			hour: "Saat",
			minute: "Dakika",
			seconds: "Saniye",
			day: "Gün",
			month: "Ay",
			week: "Hafta",
			year: "Yıl",
		},
		notifications: {
			title: "Bildirimler",
			events: "Olaylar",
			empty: "Yeni bir bildirim yok.",
			showAll: "Hepsini gör",
		},
		themeMenu: {
			light: "Açık",
			dark: "Karanlık",
			system: "Sistem"
		},
		devParameters: {
			pave1: "Güç L1",
			pave2: "Güç L2",
			pave3: "Güç L3",
			pmax1: "Güç L1 - max",
			pmax2: "Güç L2 - max",
			pmax3: "Güç L3 - max",
			pmin1: "Güç L1 - min",
			pmin2: "Güçr L2 - min",
			pmin3: "Güç L3 - min",
			vave1: "Voltaj L1",
			vave2: "Voltaj L2",
			vave3: "Voltaj L3",
			vmax1: "Voltaj L1 - max",
			vmax2: "Voltaj L2 - max",
			vmax3: "Voltaj L3 - max",
			vmin1: "Voltaj L1 - min",
			vmin2: "Voltaj L2 - min",
			vmin3: "Voltaj L3 - min",
			iave1: "Akım L1",
			iave2: "Akım L2",
			iave3: "Akım L3",
			imax1: "Akım L1 - max",
			imax2: "Akım L2 - max",
			imax3: "Akım L3 - max",
			imin1: "Akım L1 - min",
			imin2: "Akım L2 - min",
			imin3: "Akım L3 - min",
			eai1: "Aktif enerji import L1",
			eai2: "Aktif enerji import L2",
			eai3: "Aktif enerji import L3",
			eae1: "Aktif enerji export L1",
			eae2: "Aktif enerji export L2",
			eae3: "Aktif enerji export L3",
			eri1: "Reactive enerji import L1",
			eri2: "Reactive enerji import L2",
			eri3: "Reactive enerji import L3",
			ere1: "Reactive enerji export L1",
			ere2: "Reactive enerji export L2",
			ere3: "Reactive enerji export L3",
			pfave1: "Power faktör L1",
			pfave2: "Power faktör L2",
			pfave3: "Power faktör L3",
			pfmax1: "Power faktör L1 - max",
			pfmax2: "Power faktör L2 - max",
			pfmax3: "Power faktör L3 - max",
			pfmin1: "Power faktör L1 - min",
			pfmin2: "Power faktör L2 - min",
			pfmin3: "Power faktör L3 - min",
			energy3phases: "Toplam aktif enerji Export",
			renergy3phases: "Toplam reaktif enerji Export",
			power3phases: "Toplam güç",
			energy3phases_export: "Toplam aktif enerji Export",
			energy3phases_import: "Toplam aktif enerji Import",
			renergy3phases_export: "Toplam reaktif enerji Export",
			renergy3phases_import: "Toplam reaktif enerji Import",
			balance: "Bilans",
		},
		userProfile: {
			account: "Hesap",
			title: "Profil bilgileri",
			edit: "Profili düzenle",
			myProfile: "Profilim",
			language: "Dil",
			email: "E-posta adresi",
			emailTooltip: "Email adresi düzenlenemez!",
			fullname: "Tam isim",
			country: "Ülke",
			timezone: "Zaman dilimi",
			countryTooltip: "Kurulumun yapıldığı ülke, saat dilimini ayarlanması için belirtilmeli.",
			countryRequired: "Ülke seçilmesi gerekli",
			timezoneTooltip: "Cihaz zaman dilimi",
			timezoneRequired: "Zaman dilimi gerekli!",
			infoTitleOk: "Herşey yolunda!",
			infoDescriptionOk: "Hesabınızla ilgili herhangi bir sorun bulamadık.",
			infoTitleWrong: "Herşey yolunda değil!",
		},
		languages: {
			english: "İngilizce",
			polish: "Lehçe",
			turkish: "Türkçe",
		},
		forms: {
			successfullySaved: "Veriler başarıyla kaydedildi.",
			successfullyExported: "Dışa veri çıkarılması başarılı.",
			errorInSaving: "Veri kaydedilemiyor. Formu kontrol edin.",
			errorInExporting: "Dışa veri çıkarılması sırasında hata oluştu!",
			submit: "Onayla",
			discard: "Sil",
			ok: "Tamam",
			okGotIt: "Tamam, anlaşıldı!",
			edit: "Düzenle",
			cancel: "İptal",
			export: "Çıkar",
		},
		deviceOverview: {
			title: "Cihaz bilgileri",
			edit: "Cihazı düzenle",
			name: "İsim",
			friendlyName: "Yaygın isim",
			typeName: "Tip adı",
			mac: "Mac",
			modelName: "Model adı",
			registeredDate: "Kayıt Tarihi",
			modifiedDate: "Değiştirilme tarihi",
			registeredDateTooltip: "Cihazın kaydedildiği tarih",
			modifiedDateTooltip: "Cihazın kendi zamanına müdahale tarihi",
			nameTooltip: "Kullanıcı tanımlı adı",
			billingStartDate: "Faturalama periyodu başlangıç tarihi",
			billingNoMonths: "Faturalama ay sayısı",
			defaultTariff: "Faturalama tarifesi",
			location: "Lokasyon",
			notificationsFromDevice: "Cihaz bildirimleri",
			notificationsEnabled: "Aktif",
			notificationsDisabled: "Pasif",
			notifyWhenVoltageDrops: "Voltaj değeri düşmesinde bildir",
			notifyWhenVoltageRises: "Voltaj değeri yükseldiğinde bildir",
			notifyWhenTotalCosumptionAbove: "Toplam enerji tüketim değeri yükseldiğinde bildir",
			disableNotificationsAtNight: "Disable notifications at night (22:00 - 7:00)",
			muteNotifications: "Mute notifications",
			muteNotificationsInfo: "Notifications will not be sent from the telemetry system. Includes all types of notifications."
		},
		//do not translate tariff section, it is not supported in countries different than Poland :)
		tariff: {
			pageTitle: "Stats of energy consumption",
			chceckUsages: "Check usages",
			g11Description: "Podstawowa taryfa roliczenieowa. Jedna stawka za energię elektryczną o każdej porze dnia i nocy.",
			g12Description: "Taryfa dwustrefowa. Dla korzystających z energii elektrycznej głównie w nocy, w szczególności na potrzeby ogrzewania.",
			g12asDescription: "Taryfa dwustrefowa. Dostosowana do celów grzewczych.",
			g12rDescription: "Taryfa dwustrefowa. Podobna do g12, nastawiona jeszcze bardziej na zużycie energii w nocy.",
			g12nDescription: "Taryfa dwustrefowa. Rozliczenie w taryfie dzienne i nocnej z rozszerzoną strefą nocną o niedzielę.",
			g12wDescription: "Taryfa dwustrefowa. Niższa cena prądu w weekend, w nocy i wybranych godzinach dnia.",
			profitCostText: "Potentail cost/profit",
			currentConsumption: "Current consumption",
			showCosts: "Show costs",
			area1: "Day zone",
			area2: "Night zone",
			currentUsageDescription: "Energy consumption for the current month at the default tariff",
			attentionInfo: "The presented data are simulated and cannot be basis for potential claims against any subject.",
			yourTariff: "Your tariff",
			tariffsTitile: "Tariffs",
			priceArea1: "Price in area one (daily)",
			priceArea2: "Price in area two (nightly)",
			priceArea3: "Price in area third",
			priceConst: "Const price",
			priceConstInfo: "Caluclate all fixed prices from your invoice and set it here",
			g11SummaryText: "Basic household tariff",
			gxSummaryText: "You consume energy in two zones: day and night",
			area1_2: "Day/night zone",
			g11DescTitile: "Komfortowa G11",
			g12DescTitile: "Elastyczna G12",
			g12asDescTitile: "Taryfa G12as",
			g12nDescTitile: "Komfortowa G11",
			g12rDescTitile: "Komfortowa G11",
			g12wDescTitile: "Komfortowa G11",
			monday_sunday: "Monday - sunday",
			monday_saturday: "Monday - saturday",
			monday_friday: "Monday - friday",
			saturdaySunday: "Saturday, sunday and holidays",
			sundayFeasts: "Sunday and holidays",
			zone: "Zone",
			wholeDay: "Round the clock",
			tariffRule: "Tariff rule:",
			g11DescRule: "One rate for electricity at any time of the day or night. The offer will be given to those using electricity mainly during the day, not using electricity for heating purposes.",
			g12DescRule: "It enables the settlement of consumed energy in two time zones. An offer for those who use electricity mainly at night, in particular for heating purposes.",
			g12asDescRule: "Two-zone group: day and night zone.",
			g12nDescRule: "Two-zone group: day and night zones with extended night zone by Sunday.",
			g12rDescRule: "Extended two-zone group: day and night zones.",
			g12wDescRule: "An offer for customers using day and night heating, with the night zone extended to include Saturdays and Sundays",
			cheaper: "Cheaper",
			moreExpensive: "more expensive",
			nightPeriod: "Night period",
			dailyPeriod: "Daily period",
			southernPeriod: "Southern period",
			morningPeriod: "Morning period",
			eveningPeriod: "Evening period",
		},
		location: {
			indexTitle: "Lokasyonlar",
			name: "İsim",
			code: "Kod",
			address: "Adres",
			city: "Şehir",
			timezone: "Zaman dilimi",
			energyTariff: "Enerji tarifesi",
			edit: "Düzenle",
			yourLocations: "Lokasyonunuz",
			newLocationTitle: "Yeni ekle",
			availableEnergyTariffs: "Uygun tarifiler",
			resetDefaut: "Varsayılana ayarla",
			restoredDefault: "Varsayılan değerler geri yüklendi!",
			successfullyDeleted: "Lokasyon başarılı şekilde silindi!",
		},
		toasts: {
			success: "Başarılı",
			warning: "Uyarı",
			info: "Bilgi",
			help: "Yardım",
		},
		validators: {
			number: "Must be a valid number, fix your input",
			min: "Must be greater than or equal to ",
			max: "Must be less than or equal to ",
			dateRange: "Date range is required",
			parameterMin: "Please select at least one parameter",
			exportTo: "Select file type to export",
			required: "Field cannot be empty",
			warningLevelGreater: "Warning level must be less than critical level",
			warningLevelRange: "Warning level must be in range 0-50%",
			criticalLevelLess: "Critical level must be greater than warning level",
		},
		exportData: {
			title: "Verileri dışa aktar",
			parameters: "Parametreler",
			parametersHint: "Dışa çıkarılacak parametreleri seçin",
			dateRange: "Zaman aralığı seçin",
			customFileName: "Özel dosya adı",
			customFileNameHint: "Özel dosya adını tanımlayın veya boş bırakın",
			exportAllParams: "Mevcut tüm parametreleri dışa aktarın",
			exportTo: "Aktarılacak dosya tipi",
			exportUnavailableTitle: "Dışa aktarma kullanılamıyor.",
			exportUnavailableDesc: "Sunucu meşgul olduğundan dışa aktarma yapılamıyor. Daha sonra tekrar deneyin.",
			exportInBackround: "Verilerin dışa aktarılması planlandı. Dosya hazır olduğunda sizi bilgilendireceğiz.",
		},
		times: {
			min15: "15 min.",
			min30: "30 min.",
			min60: "1 hour",
			min1440: "24 hours"
		},
		providedBy: "Sağlayan:",
		manufacturer: "F&F Filipowski Sp. k.",
		pleaseWait: "Lütfen, bekleyin...",
		dashboard: "Gösterge Paneli",
		authentication: "Authentication",
		signIn: "Giriş",
		signUp: "Üye ol",
		signOut: "Çıkış",
		passwordReset: "Şifre sıfırla",
		error404: "Burada sorun yok gibi görünüyor.",
		error500: "İç Sunucu Hatası. Lütfen,sunucu yöneticisi ile iletişime geçin.",
		daily: "Günlük",
		monthly: "Aylık",
		yearly: "Yıllık",
		total: "Toplam",
		select: "Seç",
		noData: "Veri yok",
		add: "Ekle",
		rompt: "Silmek istediğinizden emin misin?",
		yes: "Evet",
		no: "Hayır",
		edit: "Düzenle",
		date: "Date",
	},
};

const i18n = createI18n({
	legacy: false,
	locale: "pl",
	globalInjection: true,
	messages,
});

export default i18n;
